export const MADRID_PLACE_ID = 'ChIJgTwKgJcpQg0RaSKMYcHeNsQ'
export const MADRID_AIRPORT_ID = '2393'

export const PARKING_TYPE_AIRPORT = 'airport'
export const PARKING_TYPE_SHARED = 'shared'
export const PARKING_TYPE_VIAT = 'viat'
export const PARKING_TYPE_DEFAULT = 'default'

export const AVAILABLE = 'available'
export const UNAVAILABLE = 'unavailable'
export const STATUS_UNAVAILABLE_BOOKING_ADVANCE_TIME_REACHED = 'unavailable advance time reached'
export const STATUS_UNAVAILABLE_BOOKING_MAX_STAY_TIME_REACHED = 'unavailable max stay time reached'
export const STATUS_UNAVAILABLE_BOOKING_MIN_STAY_NOT_REACHED = 'unavailable min stay not reached'

export const VOID_PARKING_ICON_IMAGE = '/images/parking/void.webp'
